<script setup>
import { ref } from 'vue'
import LightBox from '../LightBox'

defineProps({
    attaList: {
        type: Array,
        required: true
    }
})
const attaIndex = ref(null)
</script>
<template>
    <div v-if="attaList.length">
        <div class="gallery-box">
            <div class="img-box" v-for="(a, i) in attaList" :key="i" @click="attaIndex = i">
                <img :src="typeof a === 'object' ? (a.thumb || a.src) : a"/>
                <i v-if="typeof a === 'object' && a.type === 2" class="el-icon-video-play"></i>
            </div>
        </div>
        <LightBox :items="attaList" :index="attaIndex" @box-close="attaIndex = null" />
    </div>
</template>
<style lang="less" scoped>
.gallery-box {
    display: flex;
    flex-wrap: wrap;
    gap: 8px 10px;
    .img-box {
        position: relative;
        width: 100px;
        height: 100px;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
            max-width: 100%;
            max-height: 100%;
            object-fit: cover;
            border-radius: 6px;
        }
        i {
            color: rgba(255,255,255,.8);
            font-size: 40px;
            position: absolute;
            top: 50%-20px;
            left: 50%-20px;
        }
    }
}
</style>